import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import theme from "./Utils/theme";
import { HelmetProvider } from "react-helmet-async";
import ThemeProvider from "./theme";
import { AuthProvider } from "./Context/Auth/AuthContext";

console.log = () => {}; // Disable console.log
console.error = () => {}; // Disable console.error
console.debug = () => {};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
   <React.StrictMode>
      <AuthProvider>
         <HelmetProvider>
            <ThemeProvider>
               <App />
            </ThemeProvider>
         </HelmetProvider>
      </AuthProvider>
   </React.StrictMode>
);
